<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "@/../config";
import devicesupplierTemplate from "../components/common/form/devicesupplierTemplate.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: { devicesupplierTemplate },
  data() {
    return {
      table: {
        mname: "procurementSupplier",
        key: "id",
        url: {
          list: "/admin/system/procurementSupplier/list",
          del: "/admin/system/procurementSupplier",
        },
        output: false,
      },
      actions: [
        {
          label: "新增供应商",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          type: "info",
          onClick: this.toDownload,
          auth: "",
        },
        {
          label: "导入",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "供应商名称",
          name: "supplierName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "供应商名称",
          key: "supplierName",
          minWidth: 270,
          tooltip: "true",
          align: "center",
          render: (h, params) => {
            const text = params.row.supplierName;
            return <div style="text-align: left;">{text}</div>;
          },
        },
        {
          title: "状态",
          key: "state",
          width: 130,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "提需求"
                : row.state === 2
                  ? "需求沟通"
                  : row.state === 3
                    ? "正式立项"
                    : row.state === 4
                      ? "预算申报"
                      : row.state === 5
                        ? "上会通过"
                        : row.state === 6
                          ? "院内谈判"
                          : row.state === 7
                            ? "公开调研"
                            : row.state === 8
                              ? "招投标"
                              : row.state === 9
                                ? "签订合同"
                                : row.state === 10
                                  ? "服务中"
                                  : row.state === 11
                                    ? "lost"
                                    : row.state === 12
                                      ? "潜在"
                                      : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "性质",
          key: "supplierNature",
          minWidth: 130,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.supplierNature === 1 ? "厂家" : row.supplierNature === 2 ? "代理" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "项目经理",
          width: 130,
          tooltip: "true",
          key: "projectManager",
          align: "center",
        },
        {
          title: "联系电话",
          width: 130,
          tooltip: "true",
          key: "phone",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, row, param) => {
              let item = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.toinfo(item)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            "edit",
            "delete",
          ],
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: "devicesupplier_edit", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "devicesupplier_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    toinfo(row) {
      $utils.url.push({
        name: "devicesupplier_Info",
        query: {
          info: row,
        },
      });
    },
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/procurementSupplier/template/download`;
    },
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <devicesupplierTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></devicesupplierTemplate>
          );
        },
      });
    },
  },
};
</script>
